// Treatment Overview types — migrated from Flutter TreatmentOverviewItem & PatientSearchModel

export interface TreatmentOverviewItem {
  date: string;
  provider: string;
  provider_type: string;
  type: string;
  program: string;
  advice: string;
  pdf_url: string;
  appointment_id: string;
}

export interface PatientSearchResult {
  id: string;
  email: string | null;
  first_name: string;
  last_name: string;
  phone_number: string;
  profile_pic: string | null;
  age: number;
  gender: string;
  zarity_user_id: string;
  city: string;
}

export interface TreatmentOverviewFilters {
  /** Multi-select — null or empty array means "all providers". */
  providerType: string[] | null;
  /** Multi-select — null or empty array means "all advice types". */
  adviceType: string[] | null;
  startDate: string | null;
  endDate: string | null;
}

export const ADVICE_TYPE_OPTIONS = [
  { label: "Prescription", value: "prescription" },
  { label: "Meal Plan", value: "meal_plan" },
] as const;
